<style scoped lang="scss" type="text/scss">
    .functional-card-container {
        position: relative;
        box-sizing: border-box;
        border-radius: .15rem;
        overflow: hidden;
        transition: all .2s;

        .wrap {
            width: 100%;
        }

        &.hover-able:hover {
            cursor: pointer;

            .embed-functional-panel {
                height: 2.5rem;
            }
        }
    }
</style>

<template>
    <div class="functional-card-container" :class="{'hover-able': operable && !operating}" @click="callEdit">
        <slot></slot>
        <panel class="embed-functional-panel" v-if="operable"
               :downloadable="downloadable" :editable="editable" :removable="removable"
               @call-download="callDownload" @call-edit="callEdit" @call-remove="callRemove"
        >
        </panel>
        <loading-placeholder loading-text="操作中..." :loading="operating"></loading-placeholder>
    </div>
</template>

<script>
    import LoadingPlaceholder from '../loading-placeholder/index';
    import Panel from './panel';

    export default {
        name: '',
        props: {
            operable: {
                type: Boolean,
                default: true
            },
            downloadable: {
                type: Boolean,
                default: false
            },
            editable: {
                type: Boolean,
                default: true
            },
            removable: {
                type: Boolean,
                default: true
            }
        },
        components: {
            Panel,
            LoadingPlaceholder
        },
        data () {
            return {
                operating: false
            };
        },
        methods: {
            operated () {
                this.operating = false;
            },
            callDownload () {
                this.operating = true;
                this.$emit('call-download', this.operated);
            },
            callEdit () {
                if (!this.editable || this.operating || !this.operable) return;
                this.operating = true;
                this.$emit('call-edit', this.operated);
            },
            callRemove () {
                this.operating = true;
                this.$emit('call-remove', this.operated);
            }
        }
    };
</script>
